import script from "./Emp.vue?vue&type=script&setup=true&lang=js"
export * from "./Emp.vue?vue&type=script&setup=true&lang=js"

import "./Emp.vue?vue&type=style&index=0&id=4464d3f1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4464d3f1"]])

export default __exports__